module.exports = __webpack_public_path__ + "img/close-circle-red.aa662874.svg";